export class ConsentGate {
  private static readonly CONSENT_COOKIE = 'relay_consent_accepted';
  private static readonly ONETRUST_TIMEOUT = 1500;

  private hasInitialised = false;

  constructor(private readonly onConsent: () => void) {}

  public initialise(): void {
    if (this.hasConsentCookie()) {
      this.triggerConsent();
      return;
    }

    this.listenForConsent();
    this.startFallbackTimeout();
  }

  private triggerConsent(): void {
    if (this.hasInitialised) return;
    this.hasInitialised = true;
    this.onConsent();
  }

  private listenForConsent(): void {
    // OptanonWrapper is called by OneTrust when it loads and when consent changes.
    // Defining it before OneTrust loads ensures it's available as soon as the script fires.
    window.OptanonWrapper = () => {
      if (this.areCookiesAccepted()) {
        this.setConsentCookie();
        this.triggerConsent();
      }
    };
  }

  private startFallbackTimeout(): void {
    // If OneTrust never loads (adblock, Brave, script error etc.), hydrate after timeout.
    // If OneTrust did load but the user hasn't accepted yet, keep waiting.
    window.setTimeout(() => {
      if (!this.hasInitialised && typeof window.OneTrust === 'undefined') {
        this.setConsentCookie();
        this.triggerConsent();
      }
    }, ConsentGate.ONETRUST_TIMEOUT);
  }

  private areCookiesAccepted(): boolean {
    try {
      return window.OneTrust.IsAlertBoxClosedAndValid();
    } catch {
      return false;
    }
  }

  private setConsentCookie(): void {
    document.cookie = `${ConsentGate.CONSENT_COOKIE}=1; max-age=${60 * 60 * 24 * 365}; path=/; SameSite=Lax`;
  }

  private hasConsentCookie(): boolean {
    return document.cookie.split(';').some((c) => c.trim().startsWith(`${ConsentGate.CONSENT_COOKIE}=`));
  }
}
